module.exports = __webpack_public_path__ + "img/part4.116d2db9.png";